<template>
  <div>
    <PageTitle :title="$t('global.other')" />
    <OthersTable :others="others" />
  </div>
</template>

<script>
import { computed, onMounted } from "@vue/composition-api";
import OthersTable from "@/components/smart/tables/OthersTable";
import PageTitle from "@/components/display/PageTitle";
import store from "@/store";

export default {
  name: "OtherList",
  components: {
    OthersTable,
    PageTitle,
  },
  setup() {
    const others = computed(() => ({
      list: store.getters["others/getList"],
      status: store.getters["others/getListStatus"],
      pagination: store.getters["others/getPagination"],
      sort: store.getters["others/getSort"],
    }));

    onMounted(() => {
      store.dispatch("others/getList");
    });

    return {
      others,
    };
  },
};
</script>
